import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=7327439a&scoped=true"
import script from "./ChatItem.vue?vue&type=script&lang=ts"
export * from "./ChatItem.vue?vue&type=script&lang=ts"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=7327439a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327439a",
  null
  
)

export default component.exports